import type { RuleObject } from 'antd/es/form';

/**
 * Password validator matching Auth0 requirements:
 * - At least 10 characters
 * - At least 3 of: lowercase, uppercase, numbers, special characters
 */
export const passwordValidator: RuleObject['validator'] = (_, value) => {
  const hasLower = /[a-z]/.test(value);
  const hasUpper = /[A-Z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecial = /[^A-Za-z0-9]/.test(value);
  const typesCount = [hasLower, hasUpper, hasNumber, hasSpecial].filter(Boolean).length;

  if (!value || typesCount < 3 || value.length < 10) {
    return Promise.reject(
      new Error('Password must be at least 10 characters and contain a minimum of 3 of the following: uppercase letters, lowercase letters, numbers or special characters'
      )
    );
  }

  return Promise.resolve();
};
